import { render, staticRenderFns } from "./ZZLTable.vue?vue&type=template&id=67e1d6fa"
import script from "./ZZLTable.vue?vue&type=script&lang=js"
export * from "./ZZLTable.vue?vue&type=script&lang=js"
import style0 from "./ZZLTable.vue?vue&type=style&index=0&id=67e1d6fa&prod&lang=less"
import style1 from "./ZZLTable.vue?vue&type=style&index=1&id=67e1d6fa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports